import uuid4 from 'uuid4';

import { GetActionTypes, createAction } from 'utils/reducer/actions';

import { ToastId, AnyToastItem, ToastOptions, NotificationToastOptions } from '../../modules/ToastList/types';

const generateId = () => uuid4();

export const toastActions = {
  pushToast: (options: ToastOptions) => createAction('pushToast', options),
  pushNotificationToast: (options: NotificationToastOptions) => createAction('pushNotificationToast', options),
  editToast: (id: ToastId, options: ToastOptions) => createAction('editToast', { id, ...options }),
  editNotificationToast: (id: ToastId, options: NotificationToastOptions) =>
    createAction('editNotificationToast', { id, ...options }),
  removeToast: (id: ToastId) => createAction('removeToast', id),
  clearAllToasts: () => createAction('clearAllToasts', undefined),
};

export const toastReducer = (
  state: AnyToastItem[],
  { payload, type }: GetActionTypes<typeof toastActions>
): AnyToastItem[] => {
  switch (type) {
    case 'pushToast':
      return state.concat([{ id: payload.id || generateId(), type: 'toast', ...payload }]);
    case 'pushNotificationToast':
      return state.concat([{ id: payload.id || generateId(), type: 'notification', ...payload }]);
    case 'editToast':
      return state.map((toast) => {
        if (payload.id === toast.id) return { type: 'toast', ...payload };
        return toast;
      });
    case 'editNotificationToast':
      return state.map((toast) => {
        if (payload.id === toast.id) return { type: 'notification', ...payload };
        return toast;
      });
    case 'removeToast':
      return state.filter(({ id }) => id !== payload);
    case 'clearAllToasts':
      return [];
    default: {
      throw new Error(`Unsupported ToastAction type: ${type}`);
    }
  }
};
